import styled from 'styled-components'
import { Button, InputGroup, Dropdown, FormControl } from 'react-bootstrap'
import { colors } from '../../const/theme'
import fonts, { weight } from '../../const/fonts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface WrapperProsp {
  isMenuOpen: boolean
}

export const HeaderWrapper = styled.header`
  width: 100%;
  height: 70px;
  display: flex;
  border: 1px solid ${({ theme }) => theme?.border};
  background: ${colors.white}; 
  align-items: center;
  z-index: 1000; 
  justify-content: space-between; 
  transition: 0.3s;
`

export const Wrapper = styled.div<WrapperProsp>`
  display: flex;
  align-items: center;
  width: ${({ isMenuOpen }) => (isMenuOpen ? '14.1rem' : '5rem')};
  //border-right: 1px solid lightgray;
  position: relative;
  left: 0;
  right: 0;
  transition: 0.3s;
`

export const LogoWrapper = styled.div`
  margin: 0 auto !important;
  text-align: center;
`

export const Logo = styled.img`
  max-width: 100%;
  height: 30px;
  width: 75%;
  object-fit: contain;
`

export const HamburgerMenu = styled(Button)`
  background: none;
  border: none;
  font-size: ${fonts.medium}px;
  color: ${({ theme }) => theme?.hamburgerMenu};
  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
  }
`

export const ProfileWrapper = styled.div`
  display: flex;
  width: 65%;
  float: right;
  margin-left: auto;
  position: relative;
  @media (min-width: 769px) {
    width: 40%;
  }
`

export const CourseList = styled(InputGroup)`
  margin: auto 0;
  width: 100%;
  #course-id {
    border: 1px solid ${({ theme }) => theme.border};
    &:hover,
    &:focus {
      background: ${({ theme: { dropDown } }) => dropDown.background};
      color: ${({ theme: { dropDown } }) => dropDown.color};
    }
    color: ${colors.white};
  }
  @media (min-width: 769px) {
    width: 50%;
  }
`

export const ProfileDropDown = styled(Dropdown)`
  margin: auto;
  margin-right: 0;
  #profile-dropdown {
    color: ${colors.purple};
    border: none;
    display: flex;
    background: none;
  }
`

export const UserName = styled.label`
  color: ${colors.purple};
  margin: auto 12px;
  @media (max-width: 415px) {
    display: none;
  }
`

export const DesktopWrapper = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: 415px) {
    display: none;
  }
`

export const MobileWrapper = styled.div`
  display: flex;
  @media (min-width: 415px) {
    display: none;
  }
`

export const CourseInput = styled(FormControl)`
  background: ${colors.white} !important;
`

export const ProfileWrapper2 = styled.div`
  position: relative;
  left: 0;
  right: 0; 
  margin: auto;
  margin-right: 10px; 
`

export const ProfileImage = styled(FontAwesomeIcon)`
  display: flex;
  border-radius: 50%;
  cursor: pointer;
`

export const ProfileData = styled.div`
  background-color: white;
  border: 0.5px solid #e9edf4;
  width: 10rem;
  padding: 20px;
  right: 0;
  position: absolute;
  z-index: 1000;
  margin-top: 16px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  h3 {
    font-size: ${fonts.medium}px;
    font-weight: ${weight.bold};
    text-align: center;
    position: relative;
    text-transform: capitalize;
    z-index: 1000;
  }
  h4 {
    font-size: 13px;
    text-transform: capitalize;
    text-align: center;
  } 
`

export const LogoutButton = styled.div` 
  width: 100%;
  display: flex;
  padding: 7px 0;
  justify-content: center; 
  letter-spacing: 0.02857em;
  border-top: 1px solid #e9edf4;
  border-bottom: 1px solid #e9edf4;
  border-radius: none;
  cursor: pointer;
  &:hover,
  &:active,
  &:focus { 
    color: ${colors.black};
  }
`

export const LogoutIcon = styled(FontAwesomeIcon)`
  display: flex;
  padding-right: 7px;
  margin: auto 0;
  justify-content: center;
`
